import React from 'react';
import styled, { css } from 'styled-components';

const SkeletonBox = styled.div<{ $width?: number; $height?: number; $borderRadius?: number }>`
  ${({ $width = 100, $height = 30, $borderRadius = 3 }) => css`
   background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shine 3s infinite;
  width: ${$width}px;
  height: ${$height}px;
  border-radius: ${$borderRadius}px;
  @keyframes shine {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
  `}
`;

interface SkeletonProps {
  width?: number;
  height?: number;
  borderRadius?: number;
  style?: React.CSSProperties;
}

const Skeleton = ({ width, height, borderRadius = 0, style }: SkeletonProps) => {
  return <SkeletonBox $width={width} $height={height} $borderRadius={borderRadius} style={style} />;
};

export default Skeleton;
